module.exports = __webpack_public_path__ + "static/img/patho-bacilli-item-DMdA844b.3f972e86.png";